import classnames from 'classnames'
import Icon from '@components/Icon'
import Button from '@components/Button'
import { AppStoreBadge, GooglePlayStoreBadge } from '@components/AppDownloadBadge'

import purchaseStyles from 'subscription-flow/styles.module.scss'

const SuccessPage = () => (
    <div className="mx-auto text-center">
        <Icon type="check-circle" size="xl" />
        <h4 className="mt-6">
            <T>subscription.purchase.success.thank.you</T>
        </h4>
        <p className={classnames('mt-5', 'font-weight-bold', purchaseStyles.successMessage)}>
            <T>subscription.purchase.success.description</T>
        </p>
        <Button
            btnStyle="primary"
            className={classnames('my-4', 'mx-auto', purchaseStyles.redirectButton)}
            href="/dashboard/subscriptions">
            <T>subscription.purchase.success.btn.manage</T>
        </Button>
        <p className="mt-5 font-weight-bold">
            <T>subscription.purchase.success.download.app</T>
        </p>
        <div className="d-flex justify-content-center mt-4 mb-5">
            <AppStoreBadge linkClass={purchaseStyles.appLogos} imgClass={classnames('mr-4', purchaseStyles.appLogos)} />
            <GooglePlayStoreBadge linkClass={purchaseStyles.appLogos} imgClass={purchaseStyles.appLogos} />
        </div>
    </div>
)

export default SuccessPage
